/* src/app/features/purchase-requests/purchase-requests-list/purchase-requests-list.component.css */
.search {
  margin-top: 24px;
  margin-left: 16px;
}
.buttons {
  display: flex;
  margin-top: 50px;
}
.buttons > po-button {
  margin-right: 8px;
}
.wrapper {
  height: 0px;
}
.cart {
  cursor: pointer;
}
.warning {
  color: #be3e37;
}
.alertForm {
  margin-bottom: 20px;
}
.actions-group-buttons {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  height: 46px;
}
.footer {
  position: sticky;
  bottom: -15px;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: solid 2px rgba(128, 128, 128, 0.176);
  flex-wrap: nowrap;
}
/*# sourceMappingURL=purchase-requests-list.component.css.map */
